export default __webpack_public_path__ + "static/media/AmiyaBagchi.e494b894.png";